import * as React from 'react';
export var LucidLogo = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 32 : _b;
    return (React.createElement("svg", { fill: "currentColor", version: "1.1", viewBox: "0 0 2250 2250", height: size },
        React.createElement("path", { fill: "currentColor", d: "M 2130.6 2104.5 l -1634 0 l 0 -292 l 1342 0 l 0 -1342 l 292 0 l 0 1634 z m -393 -1634 l 0 1241 l -1241 0 l 0 -1241 l 1241 0 z m -1342 1241 l -292 0 l 0 -1634 l 1634 0 l 0 292 l -1342 0 l 0 1342 z m 1443 -1342 l 0 -393 l -1836 0 l 0 1836 l 393 0 l 0 393 l 1836 0 l 0 -1836 l -393 0 z" })));
};
//# sourceMappingURL=LucidLogo.js.map